import { defineStore } from 'pinia'

import * as advanceRequestApi from '../services/api/advance-request'
import { IApproval } from './staff'

export interface IAdvanceRequestData {
  id: number
  status: string
  is_urgent: boolean
  note: string
  reason: string
  approvals: Array<IApproval>
  amount: number
  paid_at: string
  debt_amount: number
  overdue_debt_amount: number
  images: Array<any>
  assignee_id: number
  car_id: number
  customer_id: number
  assignee: any
  car: any
  customer: any
  created_at: string
}

export const useAdvanceRequestStore = defineStore('AdvanceRequest', {
  state: () => ({
    isLoading: true,
    advanceRequest: {
      id: 0,
      status: '',
      is_urgent: false,
      note: '',
      reason: '',
      approvals: [],
      amount: 0,
      paid_at: '',
      debt_amount: 0,
      overdue_debt_amount: 0,
      images: [],
      assignee_id: 0,
      car_id: 0,
      customer_id: 0,
      assignee: {},
      car: {},
      customer: {},
      created_at: '',
    } as IAdvanceRequestData,
    advanceRequests: [] as IAdvanceRequestData[],
    count: 0,
  }),
  actions: {
    setAdvanceRequest(data: IAdvanceRequestData) {
      this.advanceRequest = data
    },
    setAdvanceRequests(data: IAdvanceRequestData[]) {
      this.advanceRequests = data
    },
    setCount(data: number) {
      this.count = data
    },
    setLoading(value: boolean) {
      this.isLoading = value
    },
    addAdvanceRequest(data: IAdvanceRequestData) {
      this.advanceRequests.push(data)
    },
    async getAdvanceRequestDetail(id: number) {
      try {
        const { data } = await advanceRequestApi.get(id)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async updateAdvanceRequest(payload: any) {
      try {
        const { data } = await advanceRequestApi.update(this.advanceRequest.id, payload)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async applyAdvanceRequest() {
      try {
        const { data } = await advanceRequestApi.apply(this.advanceRequest.id)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async rejectAdvanceRequest(payload: any) {
      try {
        const { data } = await advanceRequestApi.reject(this.advanceRequest.id, payload)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async remakeAdvanceRequest(payload: any) {
      try {
        const { data } = await advanceRequestApi.remake(this.advanceRequest.id, payload)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async approveAdvanceRequest() {
      try {
        const { data } = await advanceRequestApi.approve(this.advanceRequest.id)
        this.setAdvanceRequest(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async countAdvanceRequests() {
      try {
        const { data } = await advanceRequestApi.count()
        this.setCount(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async createAdvanceRequest(payload: any) {
      try {
        const { data } = await advanceRequestApi.create(payload)
        this.addAdvanceRequest(data)
        return data
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAdvanceRequests(params?: any) {
      try {
        this.setLoading(true)
        const result = await advanceRequestApi.list(params)
        const { data, total } = result as any
        this.setAdvanceRequests(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAllAdvanceRequests(params?: any) {
      try {
        this.setLoading(true)
        const result = await advanceRequestApi.listAll(params)
        const { data, total } = result as any
        this.setAdvanceRequests(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
  },
})
